<template>
  <div class="container">
    <div class="main" v-loading="loading">
      <div class="header">
        <div class="left">
          <div class="line-1"></div>
          <div class="line-2"></div>
          <span class="title">{{ $t('faultEdit.add') }}</span>
        </div>
        <div class="right">
          <el-button class="submit-btn" size="small" icon="el-icon-plus" @click="submitForm('ruleForm')">{{
            $t('login.submit')
            }}</el-button>
          <el-button class="back-btn" size="small" icon="el-icon-back" @click="returnBack">{{
            $t('applyChildDetail.return')
            }}</el-button>
        </div>
      </div>
      <div class="edit-box">
        <el-form :model="ruleForm" :rules="formRules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item :label="$t('goodsDetail.product')" prop="product">
            <div @click="dialogTableVisible = true"><el-input v-model.number="ruleForm.product" readonly></el-input>
            </div>
          </el-form-item>
          <el-form-item label="单位" prop="unit">
            <el-select v-model="ruleForm.unit" placeholder="请选择单位" style="width: 100%;">
              <el-option label="里拉（₺）" value="₺"></el-option>
              <el-option label="美金（$）" value="$"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="姓名" prop="userName">
            <el-input v-model="ruleForm.userName"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="specification">
            <el-input v-model="ruleForm.specification"></el-input>
          </el-form-item>

          <el-form-item label="安装地址" prop="userAddress">
            <el-input type="textarea" v-model="ruleForm.userAddress">
            </el-input>
          </el-form-item> -->

          <el-form-item :label="$t('fenQiFuKuanJinE')" prop="installmentAmount">
            <el-input v-model.number="ruleForm.installmentAmount" type="number"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shouFuJinE')" prop="downPayment">
            <el-input v-model.number="ruleForm.downPayment" type="number"></el-input>
          </el-form-item>
          <el-form-item :label="$t('fenQiQiShu')" prop="stagesNumber">
            <el-select v-model="ruleForm.stagesNumber" style="width: 100%;">
              <el-option v-for="(item, index) in datalist" :key="index" :label="item.text" :value="item.id">
              </el-option>
            </el-select>

          </el-form-item>
          <!-- <el-form-item label="银行卡" prop="bankCard">
            <el-select v-model="ruleForm.bankCard" style="width: 100%;" @change="changesel">
              <el-option v-for="(item, index) in priceUnitList" :key="index" :label="item.bankName"
                :value="item.bankCard">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="付款凭证" prop="payVoucher">
            <el-upload class="upload-demo" action="" accept="image/jpg, image/png, image/jpeg" :auto-upload="false"
              :on-change="function (file, fileList) { return uploadFile(file, fileList, 'payVoucher') }"
              :on-preview="handlePreview"
              :on-remove="function (file, fileList) { return handleRemove(file, fileList, 'payVoucher') }"
              :file-list="ruleForm.payVoucher" :limit="4" list-type="picture">
              <el-button size="small" type="primary">{{ $t('componentsReply.uploadClick') }}</el-button>
              <div slot="tip" class="el-upload__tip">{{ $t('goodsEdit.onlyPng') }}</div>
            </el-upload>
          </el-form-item> -->
          <!-- <el-form-item label="产品" prop="video">
            <VideoUpload :fileList="ruleForm.videoList" @uploadVideos="uploadVideos" :limit="1" />
          </el-form-item> -->


          <!-- <el-form-item label="信誉自保承诺书" prop="reputationGuarantee">
            <el-upload class="upload-demo" :auto-upload="false" action=""
              :on-change="function (file, fileList) { return uploadFile(file, fileList, 'reputationGuarantee') }"
              :on-preview="handlePreview"
              :on-remove="function (file, fileList) { return handleRemove(file, fileList, 'reputationGuarantee') }"
              :before-remove="beforeRemove" multiple :limit="5" :on-exceed="handleExceed"
              :file-list="ruleForm.reputationGuarantee">
              <el-button size="small" type="primary">{{ $t('componentsReply.uploadClick') }}</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="营业执照" prop="businessLicense">
            <el-upload class="upload-demo" action="" accept="image/jpg, image/png, image/jpeg" :auto-upload="false"
              :on-change="function (file, fileList) { return uploadFile(file, fileList, 'businessLicense') }"
              :on-preview="handlePreview"
              :on-remove="function (file, fileList) { return handleRemove(file, fileList, 'businessLicense') }"
              :file-list="ruleForm.businessLicense" :limit="1" list-type="picture">
              <el-button size="small" type="primary">{{ $t('componentsReply.uploadClick') }}</el-button>
              <div slot="tip" class="el-upload__tip">{{ $t('goodsEdit.onlyPng') }}</div>
            </el-upload>
          </el-form-item> -->
          <!-- <el-form-item label="产品" prop="graphicDescription">
            <el-upload class="upload-demo" action="" accept="image/jpg, image/png, image/jpeg" :auto-upload="false"
              :on-change="function (file, fileList) { return uploadFile(file, fileList, 'graphicDescription') }"
              :on-preview="handlePreview"
              :on-remove="function (file, fileList) { return handleRemove(file, fileList, 'graphicDescription') }"
              :file-list="ruleForm.graphicDescription" :limit="5" list-type="picture">
              <el-button size="small" type="primary">{{ $t('componentsReply.uploadClick') }}</el-button>
              <div slot="tip" class="el-upload__tip">{{ $t('goodsEdit.imageOrderUpload') }}</div>
            </el-upload>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <el-dialog :title="$t('chanPinXuanZe')" :visible.sync="dialogTableVisible">
      <el-table :data="gridData" ref='tab' @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" width="55">
        </el-table-column>

        <el-table-column property="name" :label="$t('warehouse.name')" width="150"></el-table-column>
        <el-table-column property="code" :label="$t('warehouse.code')" width="200"></el-table-column>
        <el-table-column property="model" :label="$t('warehouse.model')"></el-table-column>
        <el-table-column property="specification" :label="$t('warehouse.specification')"></el-table-column>
        <el-table-column fixed="right" :label="$t('warehouse.quantity')" width="180" align="center">
          <template slot-scope="scope">
            <!-- <el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">
              移除
            </el-button> -->
            <el-input-number v-model="scope.row.deviceNumber" size="small" :min="1" :max="10"></el-input-number>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page.sync="pages.current" :page-size="pages.size" :total="totals">
        </el-pagination>

      </div>
      <div slot="footer" class="dialog-footer" style="text-align: end;">
        <el-button size="small" @click="cancel">{{ $t('indexTags.cancel2') }}</el-button>
        <el-button type="primary" size="small" @click="sure">{{ $t('indexTags.sure2') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
// import { rules } from "./config/index"
import {
  uploadFile,
  getLanguageList,
  getPriceUnitList,
  addProduct,
  addParts,
  addMaterial,
  getProductDetail,
  getPartDetail,
  getMaterialDetail,
  editProduct,
  editParts,
  editMaterial,
  getProductList
} from "../../api/goods/index"

import { generalApplyDeviceAdd, shopApplyDevice } from '@/api/addDevice.js'
import VideoUpload from "../../components/upload/video-upload"
import { searchurl } from "@/api/search"
export default {
  props: {},
  components: {
    VideoUpload
  },
  data() {
    return {
      datalist: [

        ...Array.from({ length: 6 }, (_, i) => ({
          text: `${i + 1}${this.$t('hirePurchase.periodUnit')}`,
          id: i + 1
        }))
      ],
      dialogTableVisible: false,
      num: 0,
      pages: {
        current: 1,
        size: 10,
      },
      totals: 0,
      gridData: [],
      selectionList: [],
      checkList: [],
      ruleForm: {
        installmentAmount: '',
        downPayment: '',
        stagesNumber:'',
        unit: '',

        // payVoucher: [],
        // reputationGuarantee: [],
        // businessLicense: [],
        // reputationGuaranteeName: []
      },
      dataSource: [],
      formRules: {
        installmentAmount: [
           { required: true, message: this.$t('fenQiFuKuanJinebuNengWeiKong'), trigger: 'blur' },
        ],
        downPayment: [
          { required: true, message: this.$t('shouFuJinebuNengWeiKong'), trigger: 'blur' },
        ],
        stagesNumber: [
          { required: true, message: this.$t('fenQiQiShuBuNengWeiKong'), trigger: 'change' },
        ],
      },
      languageList: [],
      priceUnitList: [],
      postParams: {},
      submitApi: null,
      editApi: null,
      detailApi: null,
      loading: false
    }
  },

  computed: {
    id() {
      if (this.$route.query && this.$route.query.id) {
        return this.$route.query.id
      }
    },
    // 产品参数
    productParams() {
      const _return = {

        userName: this.ruleForm.userName,
        specification: this.ruleForm.specification,
        userAddress: this.ruleForm.userAddress,
        bankCard: this.ruleForm.bankCard,
        bank: this.ruleForm.bank,
        downPayment: this.ruleForm.downPayment,
        installmentAmount: this.ruleForm.installmentAmount,
        // businessLicense: this.ruleForm.businessLicense.length ? this.ruleForm.businessLicense.map(x => x.url).join(",") : '',
        stagesNumber: this.ruleForm.stagesNumber,
        unit: this.ruleForm.unit,
        // payVoucher: this.ruleForm.payVoucher.length ? this.ruleForm.payVoucher.map(x => x.url).join(",") : '',
        // reputationGuarantee: this.ruleForm.reputationGuarantee.length ? this.ruleForm.reputationGuarantee.map(x => x.url).join(",") : '',
        // reputationGuaranteeName: this.ruleForm.reputationGuaranteeName.length ? this.ruleForm.reputationGuaranteeName.map(x => x).join(",") : '',
      };
      return _return;
    },
    // 配件参数
    partsParams() {
      const _return = {
        id: this.id,
        name: this.ruleForm.name,
        model: this.ruleForm.model,
        code: this.ruleForm.code,
        specification: this.ruleForm.specification,
        price: this.ruleForm.price,
        unit: this.ruleForm.priceUnit,
        photo: this.ruleForm.coverImg.length ? this.ruleForm.coverImg.map(x => x.url).join(",") : '',
        partDescribe: this.ruleForm.brief,
        detail: this.ruleForm.graphicDescription.length ? this.ruleForm.graphicDescription.map(x => x.url).join(",") : '',
        slidePhoto: this.ruleForm.carousel.length ?
          this.ruleForm.carousel.map(x => x.url).concat(this.ruleForm.videoList.map(v => v.url)).join(",") : '',
        partExplain: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.url).join(",") : '',
        partExplainSize: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.size).join(",") : '',
        partExplainName: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.name).join(",") : '',
        tenantId: this.ruleForm.language
      };
      return _return;
    },
    // 辅料参数
    materialParams() {
      const _return = {
        id: this.id,
        name: this.ruleForm.name,
        model: this.ruleForm.model,
        code: this.ruleForm.code,
        specification: this.ruleForm.specification,
        price: this.ruleForm.price,
        unit: this.ruleForm.priceUnit,
        photo: this.ruleForm.coverImg.length ? this.ruleForm.coverImg.map(x => x.url).join(",") : '',
        materialDescribe: this.ruleForm.brief,
        detail: this.ruleForm.graphicDescription.length ? this.ruleForm.graphicDescription.map(x => x.url).join(",") : '',
        slidePhoto: this.ruleForm.carousel.length ?
          this.ruleForm.carousel.map(x => x.url).concat(this.ruleForm.videoList.map(v => v.url)).join(",") : '',
        materialExplain: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.url).join(",") : '',
        materialExplainName: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.name).join(",") : '',
        materialExplainSize: this.ruleForm.instructions.length ? this.ruleForm.instructions.map(x => x.size).join(",") : '',
        tenantId: this.ruleForm.language
      };
      return _return;
    }
  },
  created() {
    // this.getLanguageList();
    this.getPriceUnitList();
    if (this.id) {
      this.getDetail()
    }
    this.getProductList()
  },
  methods: {
    getProductList() {
      getProductList({ ...this.pages }).then(res => {
        if (res.data.code == 200) {
          res.data.data.records.map(v => {
            v.deviceNumber = 1
            v.deviceModel = v.model
            v.deviceSpecification = v.specification
            v.deviceName = v.name
            v.deviceCode = v.code
          })
          this.gridData = res.data.data.records
          this.pages.current = res.data.data.current
          this.totals = res.data.data.total
        }
      })
    },
    getnum() {
      let val = 0
      this.selectionList.map(v => {

        val = val + v.deviceNumber

      })

      this.num = val;

    },
    cancel() {
      this.selectionList = []
      this.$refs.tab.clearSelection()
      this.dialogTableVisible = false
    },
    sure() {
      this.checkList = JSON.parse(JSON.stringify(this.selectionList))
      console.log(this.checkList)
      let str = []
      this.checkList.map(v => {
        str.push(v.name + " x " + v.deviceNumber)
      })
      this.$set(this.ruleForm, 'product', str.toString())

      this.dialogTableVisible = false
      console.log(this.checkList, this.selectionList)
    },
    handleCurrentChange(e) {
      this.pages.current = e
      this.getProductList()
    },
    handleSelectionChange(e) {
      this.selectionList = e
    },
    changesel(e) {
      let pro = this.priceUnitList.find(v => v.bankCard === e)
      if (pro) {
        this.$set(this.ruleForm, 'bank', pro.bank)
      }
    },
    // 参数转换
    handParamsChange(e) {
      switch (e) {
        case 'product':
          this.postParams = this.productParams;
          break;
        // case 'part':
        //   this.postParams = this.partsParams;
        //   break;
        // case 'material':
        //   this.postParams = this.materialParams;
        //   break;
      }
    },
    handleSubmitApiChange(e) {
      switch (e) {
        case 'product':
          return addProduct;
        // case 'part':
        //   return addParts;
        // case 'material':
        //   return addMaterial;
      }
    },
    handleDetailApiChange(e) {
      switch (e) {
        case 'product':
          return getProductDetail;
        // case 'part':
        //   return getPartDetail;
        // case 'material':
        //   return getMaterialDetail;
      }
    },
    hadleEditApiChange(e) {
      switch (e) {
        case 'product':
          return editProduct;
        // case 'part':
        //   return editParts;
        // case 'material':
        //   return editMaterial;
      }
    },
    handleRemove(file, fileList, target) {
      let currentIndex;
      this.ruleForm[target].map((x, idx) => {
        if (file.uid === x.uid) {
          currentIndex = idx;
        }
      })
      this.ruleForm[target].splice(currentIndex, 1);
      console.log(this.ruleForm[target], target);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(this.$t('componentsReply.momentLimitThree') + `${files.length}` + this.$t('componentsReply.aTotalOf') + `${files.length + fileList.length}` + this.$t('componentsReply.individualFile'));
    },
    beforeRemove(file, fileList) {
      return this.$confirm(this.$t('componentsReply.sureRemove') + `${file.name}？`);
    },
    async uploadFile(file, fileList, target) {
      console.log('file', file);
      console.log('target', target)
      let fileList1 = [];
      let FormDatas = new FormData()
      FormDatas.append('file', file.raw);
      let { data } = await uploadFile(FormDatas);
      console.log('data', data)
      if (data && data.code === 200) {
        this.$message.success(this.$t('AAAA.uploadSuccess'))
        let obj = {
          domain: data.data.domain,
          status: "success",
          name: data.data.originalName,
          size: file.size,
          url: data.data.link,
        }
        this.ruleForm[target].push(obj)

        if (target === 'reputationGuarantee') {

          this.ruleForm.reputationGuaranteeName.push(obj.name)
          console.log(obj, this.ruleForm)
        }
      } else {
        for (var i = 0; i < fileList1.length; i++) {
          if (i + 1 == fileList1.length) {
            fileList1.splice(i, 1)
          }
        }
        this.$message.error(data.msg)
        return
      }
    },
    // 接收视频
    // uploadVideos(videoList) {
    //   console.log(videoList, 'uploadVideos')
    //   this.ruleForm.videoList = videoList;
    // },
    returnBack() {
      this.$EvenBus.$emit('menuTag', this.$route.fullPath, 'remove');
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addItem();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 新增
    async addItem() {
      this.loading = true;
      this.getnum()
      // this.submitApi = this.handleSubmitApiChange(this.$route.meta.type);
      // this.handParamsChange(this.$route.meta.type)
      this.postParams = this.productParams;
      let arr = this.selectionList.map(v => {
        return {
          ...v,
          deviceId: v.id,
          id: undefined
        };
      });
      console.log(arr)
      let obj = { ...this.postParams, itemList: arr, totalNumber: this.num }
      // let Api = this.website.roleType === 'shop' ?shopApplyDevice:generalApplyDeviceAdd
      generalApplyDeviceAdd(obj).then(res => {
        if (res.data && res.data.code === 200) {
          this.$message.success(this.$t('componentsReply.addSuccess'));
          setTimeout(() => {
            this.returnBack();
          }, 1000)
        }
        this.loading = false
      }).catch(err => {
        this.loading = false
      })

    },
    // 编辑
    async editItem() {
      this.loading = true;
      this.handParamsChange(this.$route.meta.type)
      this.editApi = this.hadleEditApiChange(this.$route.meta.type);
      const res = await this.editApi(this.postParams);
      if (res.data && res.data.code === 200) {
        this.$message.success(this.$t('faultEdit.editSuccess'));
        setTimeout(() => {
          this.returnBack();
        }, 1000)
      }
      this.loading = false;
    },
    // 获取语言列表
    // async getLanguageList() {
    //   const res = await getLanguageList();
    //   console.log('res =>', res);
    //   if (res && res.data.code === 200) {
    //     this.languageList = res.data.data;
    //   }
    // },
    // 获取价格单位
    async getPriceUnitList() {
      const res = await searchurl.genArchiveBanklist();
      console.log('res =>', res);
      if (res.data && res.data.code === 200) {
        res.data.data.map(v => {
          v.bankName = v.bank + '_' + v.bankCard
        })
        this.priceUnitList = res.data.data;
      }
    },
    // 说明书附件格式转换
    explainFormatter(arr, arr1, arr2) {
      let newArr = []
      let nameList = arr && arr.split(",");
      let urlList = arr1 && arr1.split(",");
      let sizeList = arr2 && arr2.split(",");
      if (nameList.length && urlList.length && sizeList.length) {
        urlList.map((x, idx) => {
          newArr.push({
            name: nameList[idx],
            url: x,
            size: sizeList[idx]
          })
        })
      }
      console.log('newArr', newArr);
      return newArr;
    },
    // 获取详情
    async getDetail() {
      this.loading = true;
      this.detailApi = this.handleDetailApiChange(this.$route.meta.type);
      const res = await this.detailApi(this.id);
      console.log('res =>', res.data);
      if (res.data && res.data.code === 200) {
        this.ruleForm.name = res.data.data.name;
        this.ruleForm.code = Number(res.data.data.code);
        this.ruleForm.specification = res.data.data.specification;
        this.ruleForm.model = res.data.data.model;
        this.ruleForm.price = Number(res.data.data.price);
        this.ruleForm.priceUnit = res.data.data.unit;
        this.ruleForm.language = res.data.data.tenantId;
        this.ruleForm.brief = res.data.data.productDescribe
          ? res.data.data.productDescribe : res.data.data.partDescribe
            ? res.data.data.partDescribe : res.data.data.materialDescribe
              ? res.data.data.materialDescribe : ''
        this.ruleForm.carousel = res.data.data.slidePhotoList.filter((x => x.type !== 'video'));
        this.ruleForm.videoList = res.data.data.slidePhotoList.filter((v => v.type === 'video'));
        res.data.data.photo && res.data.data.photo.split(",").map(x => {
          this.ruleForm.coverImg.push({
            url: x
          })
        })
        this.ruleForm.instructions = this.explainFormatter(res.data.data.productExplainName
          ? res.data.data.productExplainName : res.data.data.partExplainName
            ? res.data.data.partExplainName : res.data.data.materialExplainName
              ? res.data.data.materialExplainName : '',
          res.data.data.productExplain
            ? res.data.data.productExplain : res.data.data.partExplain
              ? res.data.data.partExplain : res.data.data.materialExplain
                ? res.data.data.materialExplain : '',
          res.data.data.productExplainSize
            ? res.data.data.productExplainSize : res.data.data.partExplainSize
              ? res.data.data.partExplainSize : res.data.data.materialExplainSize
                ? res.data.data.materialExplainSize : '');
        res.data.data.detail && res.data.data.detail.split(",").map(v => {
          this.ruleForm.graphicDescription.push({
            url: v
          })
        })
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #f0f2f5;
  height: 100%;
  overflow: auto;
}

.pag {
  text-align: end;
  margin-top: 10px;
}

.main {
  background-color: #fff;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 0 21px;

    .left {
      display: flex;
      align-items: center;

      .line-1 {
        width: 4px;
        height: 18px;
        background: #01AAA7;
        border-radius: 2px;
      }

      .line-2 {
        margin-left: 2px;
        width: 2px;
        height: 18px;
        background: #01AAA7;
        border-radius: 1px;
      }

      .title {
        margin-left: 9px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
      }
    }

    .right {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;

      .submit-btn {
        background-color: #01AAA7;
        color: #fff;
      }

      .back-btn {
        color: #01AAA7;
        border-color: #01AAA7;
      }
    }
  }

  .edit-box {
    width: 600px;
    padding: 23px 0;
    margin: 0 auto;
  }
}

/deep/ .upload-demo .el-button {
  background-color: #01AAA7;
  color: #fff;
  border-color: #01AAA7;
}
</style>
